<template>
  <div>
    <product-edit :product="product"/>
  </div>
</template>
<script>
  import { Tabs, TabPane } from 'src/components'
  import ProductEdit from './ProductEdit'
  import ProductRules from './ProductRules'
  import ProductJobBoard from './ProductJobBoard'
  import ProductService from 'src/services/ProductService'
  import { productType } from 'src/config/productType'

  export default {
    name: 'products-overview-settings',
    components: {
      Tabs,
      TabPane,
      ProductEdit,
      ProductRules,
      ProductJobBoard
    },
    computed: {
      isCredit () {
        return this.product.product_type === productType.CREDIT
      }
    },
    data () {
      return {
        product: {}
      }
    },
    methods: {
      async languageChange () {
        const {data} = await ProductService.getById(this.$route.params.id)
        this.product = data
      }
    },
    watch: {
      '$store.state.config.textLanguage' () {
        this.languageChange()
      },
    },
    async beforeRouteEnter (to, from, next) {
      try {
        let id = to.params.id
        let res = await ProductService.getById(id)
        let product = res.data
        if (product) {
          next(vm => {
            vm.product = product
          })
        } else {
          next(vm => vm.error = 'No data')
        }
      } catch (e) {
        next(vm => vm.error = e)
      }
    },
  }
</script>
<style lang="scss" scoped>
</style>
